import { render, staticRenderFns } from "./addMaterial.vue?vue&type=template&id=6931aa34&scoped=true&"
import script from "./addMaterial.vue?vue&type=script&lang=js&"
export * from "./addMaterial.vue?vue&type=script&lang=js&"
import style0 from "./addMaterial.vue?vue&type=style&index=0&id=6931aa34&prod&lang=scss&scoped=true&"
import style1 from "./addMaterial.vue?vue&type=style&index=1&id=6931aa34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6931aa34",
  null
  
)

export default component.exports